import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class Gases extends ChemComponent {
	constructor(props) {
		super(props);

		var search = {
			GAS_NAME: ''
		};
		
		var gasListInit = this.copyTable(gasList);
		gasListInit.query.search = this.constructSearch(search);

		this.state = {
			gasList: gasListInit,
			search: search,
			searchCount: null,
			renderKey: 0
		};
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}

	onSubmitSearch(event) {
		var newGasList = this.copyTable(gasList);
		newGasList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			gasList: newGasList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.GAS_NAME)) search.Children.push({ Attribute: 'GAS_NAME', Operator: 'like', StringValue: '%' + data.GAS_NAME + '%' });

		// if there are no terms, forget it
		if (search.Children.length === 0) search = null;
		return search;
	}
	
	addGas() {
		this.props.navigate('/HeLAD/Gases/new');
	}
	
	editGas(gasId) {
		this.props.setGasEditable(true);
		this.props.navigate('/HeLAD/Gases/' + gasId);		
	}

	viewGas(gasId) {
		this.props.setGasEditable(false);
		this.props.navigate('/HeLAD/Gases/' + gasId);		
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Gases',
			columns: exportColumns,
			entity: 'DEMURRAGE.DEM_GASES_VW',
			search: this.constructSearch(this.state.search),
			order: 'GAS_NAME'
		});
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Gases</span>
						<ChemEdit parent={this} columns={gasSearch} data={this.state.search} renderKey={this.state.renderKey} 
						  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} {...this.props} />
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='HeLAD_Gases' table={this.state.gasList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='190px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const gasSearch = [
	{ Header: 'Gas', accessor: 'GAS_NAME', row: 0, col: 0 },
];

const gasList = {
	query: { entity: 'DEMURRAGE.DEM_GASES_VW', search: null, order: 'GAS_NAME' },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addGas()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editGas(props.row.values.GAS_ID)} />, width: 25 },
		{ Header: 'ID', accessor: 'GAS_ID', width: 50,
			Cell: props => <HashLink onClick={() => props.parent.viewGas(props.value)}>{props.value}</HashLink> },
		{ Header: 'Gas', accessor: 'GAS_NAME', width: 200 },
		{ Header: 'Price', accessor: 'GAS_DEFAULT_PRICE', width: 70 },
		{ Header: 'Size', accessor: 'CYL_SIZE', width: 150 },
		{ Header: 'Description', accessor: 'DESCRIPT', width: 400 },
		{ Header: 'Praxair', accessor: 'PRAXAIR_FLAG', width: 70 },
		{ Header: props => <OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">{'View Cylinders for Gas'}</Popover.Header></Popover>}>
				<img src={props.parent.getConfig().host + '/Content/Icons/tank.gif'} alt={'View Cylinders for Gas'}/>
			</OverlayTrigger>, accessor: 'drag', width: 70,
			Cell: props => <OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">{'View Cylinders for ' + props.row.values.GAS_NAME}</Popover.Header></Popover>}>
				<HashLink onClick={() => props.parent.props.demCylindersForGas(props.row.values.GAS_ID)}>
					<img src={props.parent.getConfig().host + '/Content/Icons/tank.gif'} alt={'View Cylinders for ' + props.row.values.GAS_NAME} />
				</HashLink>
			</OverlayTrigger> }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'GAS_ID', width: 10 },
	{ Header: 'Gas', accessor: 'GAS_NAME', width: 40 },
	{ Header: 'Price', accessor: 'GAS_DEFAULT_PRICE', width: 14 },
	{ Header: 'Size', accessor: 'CYL_SIZE', width: 30 },
	{ Header: 'Description', accessor: 'DESCRIPT', width: 80 },
	{ Header: 'Praxair', accessor: 'PRAXAIR_FLAG', width: 14 }
];

export default withRouter(Gases);
